<template>
	<div class="c-detail-item flex">
		<label class="c-detail-item-label flex"><b v-if="required">*</b>{{label}}</label>
		<div class="c-detail-item-content flex-grow">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			label: String,
			
			required: Boolean
		}
	};
</script>